import { render } from "./SpicyBowlsBody.vue?vue&type=template&id=bbb9fd18&scoped=true"
import script from "./SpicyBowlsBody.vue?vue&type=script&lang=js"
export * from "./SpicyBowlsBody.vue?vue&type=script&lang=js"

import "./SpicyBowlsBody.vue?vue&type=style&index=0&id=bbb9fd18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb9fd18"]])

export default __exports__